import React from "react";

import "./dls-button.scss";
import classNames from "classnames";
import { IDSSButtonProps } from "../../building-blocks/DSSFramework";
import { ReactNode } from "react";

export const DLSButton = ({ children, onClick, variant, style, size, disabled, active, iconPosition, icon, type, ...props }: IDSSButtonProps) =>
{
    const buttonClass = classNames('hw-btn btn', {
        [ `btn-${ variant }` ]: variant,
        [ `btn-${ size }` ]: size,
        'active': active
    });

    const renderWithIcon = (): ReactNode =>
    {
        if (!iconPosition)
        {
            return children;
        }

        return (
            <>
                { iconPosition === 'left' && icon }
                { children }
                { iconPosition === 'right' && icon }
            </>
        );
    };

    return (
        <button
            { ...props }
            type={ type ?? "button" }
            className={ classNames(buttonClass, props.className, (variant === 'tertiary' || variant === 'link') ? 'no-border' : '') }
            disabled={ disabled }
            onClick={ onClick }
            style={ style }
            data-testid={ props.dataTestId ?? props.id }
        >
            { renderWithIcon() }
        </button>
    );
};